export const filterMarkers = (markersTypeToShow, markers) => {
    const dropdownMenu = document.querySelector('.c-box-building-sensors .c-dropdown__menu');

    const prepareCurrentType = (markersTypeToShow) => {
        if ('c-sensor-type--sone' === markersTypeToShow) {
            return 'sone';
        } else if ('c-sensor-type--dsw' === markersTypeToShow) {
            return 'dsw';
        } else {
            return 'all';
        }
    }


    const initFilter = prepareCurrentType(markersTypeToShow);

    for (const marker of markers) {
        marker.setVisible(false);

        if ('all' === initFilter) {
            marker.setVisible(true);
        } else {
            if (initFilter === marker.sensorType) {
                marker.setVisible(true);
            } else {
                marker.setVisible(false);
            }
        }
    }


    if (dropdownMenu) {
        const dropdownItems = dropdownMenu.querySelectorAll('.dropdown-item');

        dropdownItems.forEach((item, index) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const currentType = prepareCurrentType(item['id']);

                for (const marker of markers) {
                    marker.setVisible(false);

                    if ('all' === currentType) {
                        marker.setVisible(true);
                    } else {
                        if (currentType === marker.sensorType) {
                            marker.setVisible(true);
                        } else {
                            marker.setVisible(false);
                        }
                    }
                }
            });
        });
    }
}
